export default __webpack_public_path__ + "assets/campaign-a028552f1eb34dfafadf7b34f3cd9270.png";